export const START_BINGO_GAME_COMPLETED = "bingo/startGameCompleted";
export const SELECT_BINGO_CELL_COMPLETED = "bingo/selectCellCompleted";
export const FINISH_BINGO_GAME_COMPLETED = "bingo/finishGameCompleted";

export const SET_BINGO_FEEDBACK = "bingo/setFeedback";
export const CLEAR_BINGO_FEEDBACK = "bingo/clearFeedback";

export const TICK_BINGO_TIMER = "bingo/tickTimer";
export const RESET_BINGO_STATE = "bingo/resetState";

export const NEXT_BINGO_DRIVER = "project/bingo/nextBingoDriver";